import React from 'react';
import { useHistory } from "react-router-dom";

const ErrorPage = () => {
    const history = useHistory();


    return (
        <div class="container-fluid inner-page-space">
            <div class="wrapper">
                <div class="error-position-one">
                    <div class="error-oops-one">
                        <p>Oops!</p>
                    </div>
                    <div class="page-fourerror-one">
                        <p>404 - Page Not Found</p>
                    </div>
                    <div class="page-message-one">
                        <p>This is not the webpage you are looking for.Kindly check the mistyped web URL.</p>
                    </div >
                    <div >
                        <button onClick={() => history.push("/carList")} class="page-error-button-one">GO TO HOMEPAGE</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ErrorPage